// extracted by mini-css-extract-plugin
export default {"customDropdownContent":"FavoritesMenu_module-XZ5N22U4_customDropdownContent__uaTDZ"};